<template>
    <router-view></router-view>
</template>
<script setup lang="ts">
import { onMounted } from 'vue';
import { controlDeferred } from '@eureka/utils/control';
import { UsageAmountWhere } from '@eureka/shared/edition-upgrade/src/constants';
import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';

async function openEditionUpgradeFirstLogin() {
    const { is_first_login_after_try_end } = await controlDeferred.promise;
    if (is_first_login_after_try_end) {
        import('@eureka/shared/edition-upgrade').then((mod) => {
            mod.prepareFirstLoginAfterTrial(UsageAmountWhere.TECH_SEEK, EurekaPackageType.AIR_COMMERCIAL);
        });
    }
}

// 设置 Eureka 应用访问标识 cookie
function setEurekaVisitedCookie() {
    // 设置 cookie,180天过期,路径为根路径
    const expires = new Date();
    expires.setDate(expires.getDate() + 180);
    document.cookie = `eureka_visited=1; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
}

onMounted(() => {
    setEurekaVisitedCookie();
});

openEditionUpgradeFirstLogin();

</script>
